import { DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { GREY } from "../style/theme";
import { useExtAdminTwar } from "./ext.twar";
import { UButton, UListItemButton } from "../common/ui.buttons";
import { UFieldset } from "../common/ui.fieldset";
import { useEffect, useState } from "react";
import { UDialog } from "../common/ui.dialog";
import { UEditableTextField } from "../common/ui.editable";
import { useAdmin } from "./admin";


export function CxTwarAdminModule(props) {
    const twar = useExtAdminTwar();

    return <List>
        <Typography sx={{ color: GREY[800] }}>Alliances</Typography>
        {twar.alliances.map(a => <Alliance all={a} key={a.id} />)}
        <NewAllianceButton />
    </List>
}

const PHASES = {
    1: 'Fase 1',
    2: 'Fase 2',
    3: 'Fase 3',
}

export function CxTwarNewMatchFieldsExtModule(props) {
    const twar = useExtAdminTwar();
    const admin = useAdmin()
    const { data, setData } = props;

    useEffect(() => {
        if (!data.phase) {
            setData({ ...data, phase: twar.crusade.phase })
        }
    }, [data])

    return <>
        <Typography>Fase</Typography>
        {data.phase && <Select value={data.phase} onChange={e => setData({ ...data, phase: e.target.value })}>
            {Object.keys(PHASES).map(k => <MenuItem key={k} value={k}>
                {PHASES[k]}
            </MenuItem>)}
        </Select>}
    </>
}
export function CxTwarMatchFieldsExtModule(props) {
    const twar = useExtAdminTwar();
    const admin = useAdmin()
    const { match } = props;

    return <>
        <Typography>Fase</Typography>
        <Select
            value={match.phase}
            onChange={e => twar.editMatchField(match.id, 'phase', e.target.value)}>
            {Object.keys(PHASES).map(k => <MenuItem disabled={twar.crusade.phase > k} key={k} value={k}>
                {PHASES[k]}
            </MenuItem>)}
        </Select>
    </>
}

function NewAllianceButton() {
    const twar = useExtAdminTwar();
    const [add, setAdd] = useState({ name: '', description: '' })
    return <UDialog button={<UButton>New alliance</UButton>}>
        <DialogTitle>
            New alliance
        </DialogTitle>
        <DialogContent>
            <Stack spacing={2}>
                <TextField size="small" label="Name" value={add.name} onChange={e => setAdd({ ...add, name: e.target.value })} />
                <TextField size="small" label="Description" multiline value={add.description} onChange={e => setAdd({ ...add, description: e.target.value })} />
                <TextField size="small" label="Icon" value={add.icon} onChange={e => setAdd({ ...add, icon: e.target.value })} />
            </Stack>
        </DialogContent>
        <DialogActions>
            <UButton call={"admin/twar/crusade/" + twar.crusade.id + "/alliance/new"} payload={add} onComplete={twar.reload} color="info">Create</UButton>
        </DialogActions>
    </UDialog>
}

function Alliance(props) {
    const { all } = props;
    return <UListItemButton>
        <Stack>
            <ListItemText primary={all.name} secondary={all.description} />
            <Typography sx={{ fontSize: 12, color: GREY[800] }}>Players: {all.players.length}</Typography>
            <Typography sx={{ fontSize: 12, color: GREY[800] }}>Points: {all.points}</Typography>
        </Stack>
    </UListItemButton>
}